import React from "react";
import { Col, Row } from "react-bootstrap";
import "./Contactus.css";

import contactImg from '../../images/5124556.jpg';

// import swal from 'sweetalert'
import { motion } from "framer-motion";
import { PrincipaleButton } from "../PrincipaleButton";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { useTranslation } from "react-i18next";
import enTranslations from "../../en.json";
import arTranslations from "../../ar.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    ar: { translation: arTranslations },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

const Contact = () => {
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    event.preventDefault();
    event.target.reset();
    // swal("Thank You!", "We appreciate you contacting us!", "success");
  };

  const fadeVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  return (
    <section id="contact">
      <Col md={11} className="mx-auto">
        <Row>
          <Col md={6}>
            <motion.form
              onSubmit={handleSubmit}
              className="contactForm"
              initial="hidden"
              animate="visible"
              variants={fadeVariants}
              transition={{ duration: 2 }}
            >
              <h4 className="miniTitle">{t("contactus")}</h4>
              <h5 className="sectionTitle">{t("getintouch")}</h5>
              <Row>
                <Col md={12} lg={6}>
                  <input placeholder={t("name")} type="text" required />
                </Col>
                <Col md={12} lg={6}>
                  <input placeholder={t("email")} type="email" required />
                </Col>
                <Col md={12}>
                  <input placeholder={t("subject")} type="text" required />
                </Col>
                <Col md={12}>
                  <textarea placeholder={t("yourmessage")} required></textarea>
                </Col>
              </Row>
              <PrincipaleButton>{t("submit")}</PrincipaleButton>
            </motion.form>
          </Col>
          <Col md={6}>
            <motion.img
              src={`${contactImg}`}
              alt=""
              className="img-fluid"
              initial="hidden"
              animate="visible"
              variants={fadeVariants}
              transition={{ duration: 2 }}
            />
          </Col>
        </Row>
      </Col>
    </section>
  );
};

export default Contact;

